(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["widerruf-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.section-widerruf-form .widerruf-form');
    if (!root) return;

    const endpoint = root.dataset.endpoint;
    const locale = root.dataset.locale || 'de';
    const turnstileKey = root.dataset.turnstileKey || '';

    const panels = {
      1: root.querySelector('[data-step="1"]'),
      2: root.querySelector('[data-step="2"]'),
      success: root.querySelector('[data-step="success"]'),
      error: root.querySelector('[data-step="error"]'),
    };
    const form = root.querySelector('.widerruf-form__form');
    const review = root.querySelector('.widerruf-form__review');
    const globalError = root.querySelector('[data-global-error]');
    const successRef = root.querySelector('[data-success-ref]');

    const labels = {
      first_name: 'Vorname',
      last_name: 'Nachname',
      email: 'E-Mail',
      order_number: 'Bestellnummer',
      order_date: 'Bestelldatum',
      message: 'Mitteilung',
    };

    const fieldErrors = {
      required: 'Pflichtfeld',
      invalid: 'Ungültige E-Mail-Adresse',
    };

    function showStep(name) {
      Object.values(panels).forEach((p) => { if (p) p.hidden = true; });
      if (panels[name]) panels[name].hidden = false;
    }

    function clearErrors() {
      root.querySelectorAll('.widerruf-form__error').forEach((el) => { el.textContent = ''; });
    }

    function getData() {
      const fd = new FormData(form);
      return {
        first_name: (fd.get('first_name') || '').toString().trim(),
        last_name: (fd.get('last_name') || '').toString().trim(),
        email: (fd.get('email') || '').toString().trim(),
        order_number: (fd.get('order_number') || '').toString().trim(),
        order_date: (fd.get('order_date') || '').toString().trim(),
        message: (fd.get('message') || '').toString().trim(),
      };
    }

    function validateClient(data) {
      const errors = {};
      if (!data.first_name) errors.first_name = 'required';
      if (!data.last_name) errors.last_name = 'required';
      if (!data.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) errors.email = 'invalid';
      if (!data.order_number) errors.order_number = 'required';
      return errors;
    }

    function showFieldErrors(errors) {
      Object.entries(errors).forEach(([field, code]) => {
        const el = root.querySelector('[data-error-for="' + field + '"]');
        if (el) el.textContent = fieldErrors[code] || code;
      });
    }

    function renderReview(data) {
      review.innerHTML = '';
      Object.entries(labels).forEach(([key, label]) => {
        if (!data[key]) return;
        const dt = document.createElement('dt');
        dt.textContent = label;
        const dd = document.createElement('dd');
        dd.textContent = data[key];
        review.appendChild(dt);
        review.appendChild(dd);
      });
    }

    function getTurnstileToken() {
      if (!turnstileKey) return '';
      const input = root.querySelector('[name="cf-turnstile-response"]');
      return input ? input.value : '';
    }

    root.querySelector('[data-action="next"]').addEventListener('click', function () {
      clearErrors();
      const data = getData();
      const errors = validateClient(data);
      if (Object.keys(errors).length) {
        showFieldErrors(errors);
        return;
      }
      renderReview(data);
      showStep(2);
    });

    root.querySelector('[data-action="back"]').addEventListener('click', function () {
      showStep(1);
    });

    root.querySelector('[data-action="retry"]').addEventListener('click', function () {
      showStep(1);
    });

    root.querySelector('[data-action="submit"]').addEventListener('click', async function () {
      clearErrors();
      const btn = this;
      const data = getData();
      const payload = Object.assign({}, data, { locale: locale });

      if (turnstileKey) {
        payload.turnstile_token = getTurnstileToken();
        if (!payload.turnstile_token) {
          const el = root.querySelector('[data-error-for="turnstile"]');
          if (el) el.textContent = 'Bitte bestätigen Sie das Captcha.';
          return;
        }
      }

      btn.disabled = true;
      try {
        const res = await fetch(endpoint + '/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const json = await res.json().catch(function () { return {}; });

        if (res.status === 422 && json.fields) {
          showStep(1);
          showFieldErrors(json.fields);
          return;
        }
        if (res.status === 403 && json.error === 'captcha') {
          const el = root.querySelector('[data-error-for="turnstile"]');
          if (el) el.textContent = 'Captcha ungültig. Bitte erneut versuchen.';
          if (window.turnstile) window.turnstile.reset();
          return;
        }
        if (!res.ok || !json.ok) {
          globalError.textContent = 'Die Übermittlung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.';
          showStep('error');
          return;
        }

        successRef.textContent = 'Referenz: ' + json.reference;
        showStep('success');
      } catch (e) {
        globalError.textContent = 'Netzwerkfehler. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.';
        showStep('error');
      } finally {
        btn.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
